/**
 * Identity
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoleTenant } from './role-tenant';

export interface RoleResponse {
  id: string;
  name: string;
  code: string;
  isSystem: boolean;
  tenant?: RoleTenant;
  permissionIds?: Array<string> | null;
}
